import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class ProductFilterTagsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "tag", `/api/v1/account/tags`);
  }
}
